import { lazy } from 'react';

import { useRouterStore } from '@/store/routerStore';

import { Notifications } from '../notifications';

const LazySubmitAuditModal = lazy(() => import('../submit-audit-modal/submit-audit-modal'));

export const GlobalComponents = () => {
  const isSubmitAuditModalOpen = useRouterStore((state) => !!state.submitAuditModalCaseUuid);

  return (
    <>
      <Notifications />
      {isSubmitAuditModalOpen && <LazySubmitAuditModal />}
    </>
  );
};
